module.exports = __webpack_public_path__ + "img/small-avito.a5bd415f.svg";